import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ENV } from './config';
import { initRUM } from './observability/faro';
import FaroErrorBoundary from './observability/FaroErrorBoundary';

// Initialize RUM before render so early errors/web-vitals are captured. No-op
// when REACT_APP_FARO_URL is empty (local dev).
initRUM({
  appName: ENV.REACT_APP_FARO_APP_NAME || 'customer-portal',
  environment: ENV.REACT_APP_ENVIRONMENT,
  collectorUrl: ENV.REACT_APP_FARO_URL,
  // Attach W3C traceparent to these backends so browser spans link to server traces.
  apiAllowedUrls: [ENV.REACT_APP_REST_API, ENV.REACT_APP_CENTRAL_AUTH],
  version: process.env.REACT_APP_VERSION || '1.0.0',
  sessionSampleRate: Number(ENV.REACT_APP_FARO_SAMPLE_RATE ?? 1),
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FaroErrorBoundary>
      <App />
    </FaroErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
